/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InactiveCleanupCandidateDTOFromJSON, InactiveCleanupCandidateDTOToJSON, } from './InactiveCleanupCandidateDTO';
/**
 * Check if a given object implements the InactiveCleanupExportDTO interface.
 */
export function instanceOfInactiveCleanupExportDTO(value) {
    return true;
}
export function InactiveCleanupExportDTOFromJSON(json) {
    return InactiveCleanupExportDTOFromJSONTyped(json, false);
}
export function InactiveCleanupExportDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rows': json['rows'] == null ? undefined : (json['rows'].map(InactiveCleanupCandidateDTOFromJSON)),
        'truncated': json['truncated'] == null ? undefined : json['truncated'],
        'limit': json['limit'] == null ? undefined : json['limit'],
    };
}
export function InactiveCleanupExportDTOToJSON(json) {
    return InactiveCleanupExportDTOToJSONTyped(json, false);
}
export function InactiveCleanupExportDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'rows': value['rows'] == null ? undefined : (value['rows'].map(InactiveCleanupCandidateDTOToJSON)),
        'truncated': value['truncated'],
        'limit': value['limit'],
    };
}
